// import {CurrencyType} from '@/services/coins/constants/currencyType';

import { isEmpty } from 'lodash'

const defaultPairs = ['BTC-USDTERC', 'ETH-BTC', 'BTC-BNB', 'BCH-BTC', 'BTC-ADA', 'ETH-LTC']

// const pair = {
//   pairName: 'BTC-EUR',
//   rate: '',
//   prevRate: '',
//   from: 'EUR',
//   to: 'BTC',
//   inputTypeFrom: CurrencyType.FIAT,
//   inputTypeTo: CurrencyType.FIAT,
// };

const getInitialPrices = (pairs = []) => {
    const pairsToInit = isEmpty(pairs) ? defaultPairs : pairs
    return Object.fromEntries(Array.from(pairsToInit, e => [e, ['...', '...']])) // first is current and second is previous
}

const initialPrices = getInitialPrices()

const pricesReducer = (state, action) => {
    const { type, payload } = action

    switch (type) {
        case 'bulkPricesUpdate': {
            return {
                ...state,
                ...payload,
            }
        }
        case 'changeBTCEUR': {
            return {
                ...state,
                'BTC-USDT': payload,
            }
        }
        case 'changeETHBTC': {
            return {
                ...state,
                'ETH-BTC': payload,
            }
        }
        case 'changeBTCUSD': {
            return {
                ...state,
                'BTC-BNB': payload,
            }
        }
        case 'changeDOGEXVG': {
            return {
                ...state,
                'DOGE-XVG': payload,
            }
        }
        case 'changeBCHBTC': {
            return {
                ...state,
                'BCH-BTC': payload,
            }
        }
        case 'changeBTCRUB': {
            return {
                ...state,
                'BTC-ADA': payload,
            }
        }
        case 'changeETHEUR': {
            return {
                ...state,
                'ETH-LTC': payload,
            }
        }
        default:
            return state
    }
}

export { defaultPairs, initialPrices, getInitialPrices, pricesReducer }
